import * as React from "react";
import Code from "app/components/docs/shared/code";

type Props = {
  children: React.ReactNode;
  language?: string;
};

export default function CodeBlock(props: Props) {
  return (
    <pre className="border border-gray rounded bg-silver overflow-auto p2 monospace">
      <Code {...props} />
    </pre>
  );
}
